module.exports = __webpack_public_path__ + "static/media/SK4.70318649.jpg";